export const handleResponse = async (response) => {
    const data = await response.json()
    // //console.log("data", data)
    return data;
}   